import { DatePicker, Select, Button, Input, Row, Col } from "antd";

export function FilterBar({ filters, setFilters, onFilter }) {
  return (
    <Row gutter={[8, 8]} style={{ marginBottom: 6 }}>
      {/* Ngày thăm */}
      <Col xs={24} sm={12} md={6}>
        <DatePicker
          placeholder="Ngày thăm"
          style={{ width: "100%" }}
          value={filters.date}
          onChange={(value) =>
            setFilters((prev) => ({ ...prev, date: value }))
          }
        />
      </Col>

      {/* Trạng thái */}
      <Col xs={24} sm={12} md={5}>
        <Select
          placeholder="Trạng thái"
          allowClear
          style={{ width: "100%" }}
          value={filters.status}
          onChange={(value) =>
            setFilters((prev) => ({ ...prev, status: value }))
          }
        >
          <Select.Option value="cho_duyet">Chờ duyệt</Select.Option>
          <Select.Option value="da_duyet">Đã duyệt</Select.Option>
          <Select.Option value="huy">Đã hủy</Select.Option>
        </Select>
      </Col>

      {/* Tên quân nhân */}
      <Col xs={24} sm={24} md={4}>
        <Input
          placeholder="Tên quân nhân"
          style={{ width: "100%" }}
          value={filters.name}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, name: e.target.value }))
          }
        />
      </Col>

      <Col xs={24} sm={24} md={3}>
        <Input
          placeholder="Đơn vị"
          style={{ width: "100%" }}
          value={filters.don_vi}
          onChange={(e) =>
            setFilters((prev) => ({ ...prev, don_vi: e.target.value }))
          }
        />
      </Col>

      {/* Nút tìm kiếm */}
      <Col xs={24} sm={24} md={6}>
        <Button
          type="primary"
          style={{ width: "100px" }}
          block
          onClick={() => onFilter(filters)}
        >
          Tìm kiếm
        </Button>
      </Col>
    </Row>
  );
}
